"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateResultComponent = CalculateResultComponent;
const Elements = __importStar(require("@genesys/client-core/lib/elements"));
const ResultComponent = __importStar(require("@genesys/client-core/lib/result-component"));
const property_1 = require("@genesys/property");
const React = __importStar(require("react"));
const groupName = "FanMotorProToolResults";
// export function CalculateResultComponent(props: Props) {
//   return (
//     <Elements.StandardContainer>
//       <Elements.FlexContainerRowWithPadding>
//         <Elements.InnerContainer>
//           <Elements.InnerContainer>
//             <Elements.FlexContainerRowWithPadding>
//               {props.results!.map((r, i) => {
//                 const airHumidityOutConversionParameters = {
//                   pressure: props.pressureIn,
//                   temperature: PropertyValueSet.getAmount<Quantity.Temperature>(
//                     "airtemperatureout",
//                     r.result
//                   )!
//                 };
//                 return (
//                   <ResultComponent.Container
//                     key={i}
//                     showLabels={i === 0}
//                     properties={r.result}
//                     propertyDefinitions={props.resultDefinitions.map(
//                       (resultDefinition) =>
//                         resultDefinition.propertyName === "airhumidityout"
//                           ? {
//                               ...resultDefinition,
//                               conversionParameters:
//                                 airHumidityOutConversionParameters
//                             }
//                           : resultDefinition
//                     )}
//                     fieldGroup={groupName}
//                   />
//                 );
//               })}
//             </Elements.FlexContainerRowWithPadding>
//           </Elements.InnerContainer>
//         </Elements.InnerContainer>
//         {props.results!.filter((r) => r.error !== undefined).length > 0 ? (
//           <Elements.InnerContainer>
//             <Elements.H3>Errors</Elements.H3>
//             {props.results!.length === 1 ? (
//               <div>{props.results![0].error}</div>
//             ) : (
//               props.results!.map(
//                 (r, ix) =>
//                   r.error && (
//                     <div key={ix}>
//                       Case #{ix + 1}: {r.error}
//                     </div>
//                   )
//               )
//             )}
//           </Elements.InnerContainer>
//         ) : null}
//       </Elements.FlexContainerRowWithPadding>
//     </Elements.StandardContainer>
//   );
// }
function CalculateResultComponent({ results, pressureIn, resultDefinitions }) {
    if (!(results === null || results === void 0 ? void 0 : results.length)) {
        return null;
    }
    return (React.createElement(Elements.DataPresenterTable, null,
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("th", null),
                " ",
                results.map((_, i) => (React.createElement("th", { key: i },
                    "Case ",
                    i + 1))))),
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("th", null, "Errors"),
                results.map((r, i) => (React.createElement("td", { key: i }, r.errors.map((e) => (React.createElement("div", { key: e.code },
                    e.code.toString(),
                    " ",
                    e.text))))))),
            React.createElement("tr", null,
                React.createElement("th", null, "Warnings"),
                results.map((r, i) => (React.createElement("td", { key: i }, r.warnings.map((w) => (React.createElement("div", { key: w.code },
                    w.code.toString(),
                    " ",
                    w.text))))))),
            React.createElement("tr", null,
                React.createElement("th", null, "Result"),
                results.map((r, i) => {
                    const temperature = property_1.PropertyValueSet.getAmount("airtemperatureout", r.result);
                    const conversionParameters = {
                        pressure: pressureIn,
                        temperature
                    };
                    const propertyDefinitions = resultDefinitions.map((def) => def.propertyName === "airhumidityout"
                        ? Object.assign(Object.assign({}, def), { conversionParameters }) : def);
                    return (React.createElement("td", { key: i },
                        React.createElement(ResultComponent.Container, { showLabels: i === 0, properties: r.result, propertyDefinitions: propertyDefinitions, fieldGroup: groupName })));
                })))));
}
//# sourceMappingURL=container-component.js.map